"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const clsx_1 = __importDefault(require("clsx"));
const TableHeadingDecoration_1 = __importDefault(require("@Components/ViewWork/Table/TableHeadingDecoration"));
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const AddPlaceButton_1 = require("@Components/Buttons/AddPlaceButton");
const zod_1 = require("zod");
const zod_2 = require("@hookform/resolvers/zod");
const Table_1 = __importDefault(require("@Components/ViewWork/Table"));
const TableGlobalError_1 = __importDefault(require("@Components/ViewWork/Table/TableGlobalError"));
const TablesForm = ({ className, headingDecoration, tableInfos, footerRow, addButtonTitle, hideAddButton, onAddButtonClicked, validationSchema, rowsAreValid, onFormSubmitted, onRemoveCellClicked, shouldFocusError = false, useAlternateHeader, }) => {
    const resolverOptions = () => {
        if (validationSchema) {
            return {
                resolver: (0, zod_2.zodResolver)(zod_1.z.object({
                    rows: validationSchema,
                })),
            };
        }
        return {};
    };
    const methods = (0, react_hook_form_1.useForm)(Object.assign(Object.assign({}, resolverOptions()), { mode: 'all', reValidateMode: 'onChange', shouldUnregister: true, shouldFocusError: shouldFocusError }));
    const onSubmit = (data) => {
        onFormSubmitted && onFormSubmitted(data);
    };
    (0, react_1.useEffect)(() => {
        const callback = methods.subscribe({
            formState: {
                values: true,
            },
            callback: () => {
                methods.handleSubmit(onSubmit)();
            },
        });
        return () => callback();
    }, [methods.subscribe, methods.handleSubmit, onSubmit]);
    const tableInfoRowCount = tableInfos.map((tableInfo) => tableInfo.rows.length).reduce((a, b) => a + b, 0);
    (0, react_1.useEffect)(() => {
        rowsAreValid && rowsAreValid(methods.formState.isValid);
    }, [methods.formState.isValid, rowsAreValid]);
    // Forces revalidation when data is modified outside of form
    (0, react_1.useEffect)(() => {
        methods.trigger().then();
    }, [methods.trigger, tableInfoRowCount]);
    const removeCellClicked = (removedCellIndex, removeCellIdentifier) => {
        onRemoveCellClicked &&
            onRemoveCellClicked(removedCellIndex, removeCellIdentifier, methods.reset, methods.getValues());
    };
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
        react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit), className: (0, clsx_1.default)('table-overflow-container', className) },
            react_1.default.createElement("div", { className: 'table-layout' },
                headingDecoration && (react_1.default.createElement(TableHeadingDecoration_1.default, { title: headingDecoration.title, icon: headingDecoration.icon, toolTip: headingDecoration.toolTip, required: headingDecoration.required, rowLength: tableInfoRowCount, useAlternateHeader: useAlternateHeader, rightData: headingDecoration.rightData })),
                tableInfos.map((tableInfo, tableInfoIndex) => (react_1.default.createElement(Table_1.default, { headerRow: tableInfo.headerRow, rows: tableInfo.rows, footerRow: footerRow, onRemoveCells: (removedCellIndex, removeCellIdentifier) => removeCellClicked(removedCellIndex, removeCellIdentifier), key: tableInfoIndex }))),
                react_1.default.createElement("div", { className: 'add-place-button-container' },
                    !hideAddButton && (react_1.default.createElement(AddPlaceButton_1.AddPlaceButton, { title: addButtonTitle !== null && addButtonTitle !== void 0 ? addButtonTitle : 'ADD', onClick: onAddButtonClicked })),
                    react_1.default.createElement(TableGlobalError_1.default, null))))));
};
exports.default = TablesForm;
